import script from "./gitconfigs.vue?vue&type=script&setup=true&lang=ts"
export * from "./gitconfigs.vue?vue&type=script&setup=true&lang=ts"

import "./gitconfigs.vue?vue&type=style&index=0&id=28a096dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a096dc"]])

export default __exports__